export interface MilestoneOffer {
  id: string;
  name: string;
  unlockLevel: number;
  price: string;
  durationHours: number;
  rewards: {
    coins: number;
    gems: number;
    starTickets: number;
    boxes: {
      diamond: number;
    };
    prisms: {
      stars: number;
      count: number;
    };
  };
  description: string;
}

export const MILESTONE_OFFERS: MilestoneOffer[] = [
  {
    id: 'milestone_lvl_5',
    name: 'Starter Bundle',
    unlockLevel: 5,
    price: '$0.99',
    durationHours: 48,
    rewards: {
      coins: 25000,
      gems: 50,
      starTickets: 0,
      boxes: { diamond: 1 },
      prisms: { stars: 3, count: 1 }
    },
    description: 'Perfect starter pack with a guaranteed 3-Star Prism and Diamond Box!'
  },
  {
    id: 'milestone_lvl_10',
    name: 'Q Initiate Pack',
    unlockLevel: 10,
    price: '$2.99',
    durationHours: 48,
    rewards: {
      coins: 50000,
      gems: 100,
      starTickets: 0,
      boxes: { diamond: 2 },
      prisms: { stars: 3, count: 1 }
    },
    description: 'Boost your collection with Diamond Boxes and a legendary 3-Star Prism core!'
  },
  {
    id: 'milestone_lvl_15',
    name: 'Star Burst Recruit Stash',
    unlockLevel: 15,
    price: '$4.99',
    durationHours: 48,
    rewards: {
      coins: 0,
      gems: 200,
      starTickets: 1,
      boxes: { diamond: 3 },
      prisms: { stars: 3, count: 2 }
    },
    description: 'Includes a Star Ticket to unlock Star Burst mode and multiple 3-Star Prisms!'
  },
  {
    id: 'milestone_lvl_20',
    name: 'Prism Core Surge',
    unlockLevel: 20,
    price: '$9.99',
    durationHours: 72,
    rewards: {
      coins: 30000,
      gems: 500,
      starTickets: 1,
      boxes: { diamond: 5 },
      prisms: { stars: 3, count: 3 }
    },
    description: 'Power up your scores with a massive influx of 3-Star cores and Diamond Boxes!'
  },
  {
    id: 'milestone_lvl_25',
    name: 'Star Burst Overdrive',
    unlockLevel: 25,
    price: '$14.99',
    durationHours: 72,
    rewards: {
      coins: 60000,
      gems: 500,
      starTickets: 2,
      boxes: { diamond: 7 },
      prisms: { stars: 3, count: 4 }
    },
    description: 'Ultimate value containing multiple Star Tickets and legendary Anima cores!'
  },
  {
    id: 'milestone_lvl_30',
    name: 'Cosmic Master Sovereign',
    unlockLevel: 30,
    price: '$24.99',
    durationHours: 72,
    rewards: {
      coins: 150000,
      gems: 500,
      starTickets: 3,
      boxes: { diamond: 10 },
      prisms: { stars: 3, count: 5 }
    },
    description: 'The sovereign master pack loaded with Diamond Boxes and premium resources!'
  },
  {
    id: 'milestone_lvl_40',
    name: 'Cosmic Overlord Stash',
    unlockLevel: 40,
    price: '$19.99',
    durationHours: 72,
    rewards: {
      coins: 250000,
      gems: 0,
      starTickets: 5,
      boxes: { diamond: 10 },
      prisms: { stars: 3, count: 5 }
    },
    description: 'Unlocks 250,000 Coins, 10 Diamond Boxes, 5 3-Star Anima Tickets, and 5 Star Tickets!'
  },
  {
    id: 'milestone_lvl_50',
    name: 'Eternal Apex Artifact',
    unlockLevel: 50,
    price: '$24.99',
    durationHours: 72,
    rewards: {
      coins: 400000,
      gems: 500,
      starTickets: 5,
      boxes: { diamond: 10 },
      prisms: { stars: 3, count: 5 }
    },
    description: 'Unlocks 400,000 Coins, 500 Hoshi gems, 10 Diamond Boxes, 5 3-Star Anima Tickets, and 5 Star Tickets!'
  }
];
